
class operators {
    constructor(
        id,
        name,
        level,
        nameLevel,
    ) {
        this.id = id;
        this.name = name;
        this.level = level;
        this.nameLevel = nameLevel;
    }
    static fromJson({
        operId,
        nomOper,
        nivel,
        nomNivel
    }) {
        return new operators(
            operId,
            nomOper,
            nivel,
            nomNivel
        );
    }
}
export default operators;
